import { InjectionToken } from "@angular/core";
import { PaetepCfMapperTemplate } from "../interfaces/paetep-cf-mapper-template.interface";

export const PaetepCfMapperConfig = new InjectionToken<PaetepCfMapperTemplate<any, any, any, any>[]>('PaetepCfMapperConfig');
